<template>
    <div class="formychat-widgets">
        <Widget v-for="widget in widgets" :key="widget.id" :widget="widget" />
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import Widget from './Widget.vue';

const isLocked = formychat_vars.is_premium == '1' ? false : true;

const postId = formychat_vars.current.post_id || 0;
const postType = formychat_vars.current.post_type || 'page';
// const isHome = formychat_vars.current.is_home || formychat_vars.current.is_front_page || false;

const widgets = computed(() => {
    return formychat_vars.data.widgets?.filter(widget => {
        if (isLocked) return true;

        const exclude_pages = widget.config.target.exclude_pages || [];
        const exclude_all_pages = widget.config.target.exclude_all_pages || false;
        const exclude_all_pages_except = widget.config.target.exclude_all_pages_except || [];

        const exclude_posts = widget.config.target.exclude_posts || [];
        const exclude_all_posts = widget.config.target.exclude_all_posts || false;
        const exclude_all_posts_except = widget.config.target.exclude_all_posts_except || [];

        if (postType === 'page') {
            if (exclude_all_pages) return exclude_all_pages_except.some(page => page == postId);
            return !exclude_pages.some(page => page == postId);
        }

        if (postType === 'post') {
            if (exclude_all_posts) return exclude_all_posts_except.some(post => post == postId);
            return !exclude_posts.some(post => post == postId);
        }

        // No restriction for home, CPTs, archives, etc.
        return true;
    });
    // Style clamping ("custom" options, colors, message template) for locked
    // users is applied server-side via the `formychat_widget_config` filter
    // (see includes/models/class-widget.php), so `formychat_vars.data.widgets`
    // already arrives clamped here.
});

onMounted(() => {
    // Trigger new event formychat_app_loaded
    const event = new CustomEvent('formychat_app_loaded', {
        detail: { 
            formychat_app_loaded: true,
            widgets: widgets.value
        }
    });
    document.dispatchEvent(event);
    
    // Legacy support for old event name (deprecated)
    const legacyEvent = new CustomEvent('formychat_loaded', {
        detail: {
            formychat_loaded: true,
            widgets: widgets.value
        }
    });
    document.dispatchEvent(legacyEvent);
})

</script>
